<template lang="pug">
    div#partner-component
        div.columns
            div.column
                strong.title Our Partners
        div.columns.logos
            div.column(v-for="slide in slides")
                div.logo-image-center.is-flex
                    a(:href="slide.link", target="_blank")
                        figure
                            img(:src="slide.image")

</template>

<script>
export default {
    name: 'partners',
    data: function () {
        return {
            baseUrl: process.env.BASE_URL,
            slides: [
                {
                    link: 'https://www.scify.gr',
                    image: 'img/partner_logos/SciFY_128.png'
                },              
                {
                    link: 'https://www.cableworks.gr/',
                    image: 'img/partner_logos/cableworks_128.png'
                },
                {
                    link: 'https://grobotronics.com/',
                    image: 'img/partner_logos/grobotronics_128.png'
                },
                {
                    link: 'https://www.marinetraffic.com/',
                    image: 'img/partner_logos/MarineTraffic_128.png'
                },
                {
                    link: 'https://vetasa.gr/',
                    image: 'img/partner_logos/logo_vega_128.png'
                },
                {
                    link: 'https://www.vision2watch.gr/',
                    image: 'img/partner_logos/vision2watch_128.jpg'
                },
                {
                    link: 'https://www.jampedals.com/',
                    image: 'img/partner_logos/JAM_128.png'
                },                
                {
                    link: 'https://el-gr.facebook.com/thiva.airport/',
                    image: 'img/partner_logos/aerolesxi_thivon_128.jpg'
                },
            ]
        }
    }
    
}
</script>

<style scoped>
.logos {
    border-bottom-style: solid;
    border-bottom-color: rgb(111, 111, 111);
    border-bottom-width: 1px;
    margin-bottom: 2rem;

    border-top-style: solid;
    border-top-color: rgb(111, 111, 111);
    border-top-width: 1px;
    margin-top: 1rem;

    /* background-color: #E8E8E8; */
    background-color: white;

    margin-left: 0px;
    margin-right: 0px;
}

.logo-image-center {
    justify-content: center;
}

#partner-component {
    margin-top: 3rem;
}

</style>

